exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subfolders[data-v-1cbb078f]{max-height:400px;overflow-y:auto}.subfolders-list tbody tr:first-child td[data-v-1cbb078f]{border-top:none}", ""]);

// exports
